'use strict';

// var globalToastHelpers = require('../globalToast/globalToastHelpers');
const pidRegex = /\//g;

/**
 * updates quantity buttons state
 * @param {Object} context clicked button JQery element
 * @param {number} currentQty selected quantity
 */
function updateQtyBtn(context, currentQty) {
    context.closest('.c-qty-section').each(function () {
        var pid = $(this).attr('data-pid');
        var encodedPID = pid ? pid.replace(pidRegex, '\\/') : '';
        var $input = $('[data-quantity-count="quantity-count-' + encodedPID + '"]');
        var minus = $('.c-min-btn-' + encodedPID);
        var currentSelectedValue = currentQty || parseInt($input.val(), 10);
        var minVal = Number($(minus).attr('data-qty-min'));

        if (currentSelectedValue === minVal) {
            minus.prop('disabled', true);
        } else {
            minus.prop('disabled', false);
        }
    });
}

/**
 * validates quantity from provided element
 * @param {Object} quantityElement quantity element
 * @param {boolean} checkOldValue true if old value has to be validated
 * @returns {Object} containing details about quantity validation
 */
function validateQuantity(quantityElement, checkOldValue) {
    var isValidQuantity = true;
    var qtyInRange = true;
    var quantity = Number(quantityElement.val());

    if (checkOldValue) {
        quantity = Number(quantityElement.attr('data-old-value'));
    }

    var minVal = Number(quantityElement.attr('data-qty-min'));
    var maxVal = Number(quantityElement.attr('data-qty-max'));

    if (!Number.isInteger(quantity)) {
        isValidQuantity = false;
    }

    if (quantity < minVal || quantity > maxVal) {
        qtyInRange = false;
        isValidQuantity = false;
    }

    return {
        isValidQuantity: isValidQuantity,
        qtyInRange: qtyInRange
    };
}

module.exports = {
    updateQtyBtn: updateQtyBtn,
    validateQuantity: validateQuantity
};
